import type { ReactNode } from "react";

export const CASCADE_AUTHOR_ID = "CASCADE_ORCH";

const URL_PATTERN = /https?:\/\/[^\s"<>]+/g;
const TRAILING_PUNCTUATION = /[!),.:;?]+$/;

/** Splits note text into plain strings and new-tab anchors for each http(s) URL. */
export function linkifyNote(note: string): ReactNode[] {
  const parts: ReactNode[] = [];
  let cursor = 0;

  for (const match of note.matchAll(URL_PATTERN)) {
    const url = match[0].replace(TRAILING_PUNCTUATION, "");
    const start = match.index;
    if (start > cursor) {
      parts.push(note.slice(cursor, start));
    }
    parts.push(
      <a
        key={start}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="break-all text-blue-700 hover:underline"
      >
        {url}
        <span className="sr-only"> (opens in new tab)</span>
      </a>
    );
    cursor = start + url.length;
  }

  if (cursor < note.length) {
    parts.push(note.slice(cursor));
  }
  return parts;
}
